// AI asistan admin uçları: https://api.glowytics.com/api/pixel/chat/admin/*?brandId=...
export const API = 'https://api.glowytics.com';
export const BRAND_ID = '8a07ce35-0fb3-4019-b0b2-60617b3c1d29'; // hosgelsin (backend'de de kilitli)

export async function chatApi(path, { method = 'GET', body, query = {} } = {}) {
  const qs = new URLSearchParams({ brandId: BRAND_ID });
  Object.entries(query).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') qs.set(k, v); });
  const r = await fetch(`${API}/api/pixel/chat/admin${path}?${qs}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await r.json(); } catch (e) { /* gövde yok */ }
  if (!r.ok) throw new Error(data?.error || data?.message || (r.status === 403 ? 'Bu sayfaya erişimin yok' : `HTTP ${r.status}`));
  return data;
}

export const fmtDate = (v) => (v ? new Date(v).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : '-');
export const fmtMoney = (v) => `$${Number(v || 0).toFixed(4)}`;
// Katalog fiyatı backend'de zaten biçimli metin gelir ("1.350,00₺"); sayıysa TL ekle
export const fmtTry = (v) => (v == null || v === '' ? '-' : typeof v === 'number' ? `${v.toLocaleString('tr-TR')} TL` : String(v));
